import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import translationENG from "./locales/eng/translation.json"
import translationSA from "./locales/sa/translation.json"

// the translations
// Keyed by "en" (not "eng") to match the `lng`/`fallbackLng` values below and
// the language codes used by the language switcher (common/languages.js,
// LanguageDropdown.js) — a mismatch here means i18next can't find any
// resource bundle for "en", so every t() call silently falls back to
// returning the raw key name instead of a translated string (e.g. showing
// literal "minute_plural second_plural" instead of "5 minutes 30 seconds").
const resources = {
  en: {
    translation: translationENG,
  },
  sa: {
    translation: translationSA,
  },
}

const language = localStorage.getItem("I18N_LANGUAGE")
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "en")
}
i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "en",
    fallbackLng: "en", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
